<div class="user-icon" [style.background-color]="color">
  {{ initials }}
</div>
